/**
 * Material Icons Font Loading
 * Hides icons until fonts are fully loaded to prevent FOUT
 */
(() => {
    if ('fonts' in document) {
        document.fonts.ready.then(() => {
            document.documentElement.classList.add('fonts-loaded');
        });
    } else {
        // Fallback for older browsers - show after window load
        window.addEventListener('load', () => {
            document.documentElement.classList.add('fonts-loaded');
        });
    }
})();
